import { NgModule } from '@angular/core';

import { DownloadUrlSuffixPipe } from './download-url-suffix.pipe';

@NgModule({
    imports: [],
    exports: [DownloadUrlSuffixPipe],
    declarations: [DownloadUrlSuffixPipe],
    providers: [],
})
export class DownloadUrlSuffixPipeModule { }
